  <template>
  <div
    class="yk-interactions__container__share yk-interactions__container__share-last-new is-line-left-solid"
  >
    <div class="yk-interactions--header" style="padding-right:0px;">
      <span class="interaction-tips">讨论</span>
      <!-- <el-button @click="auditingActivity" v-if="userType==0">审核</el-button> -->
      <el-input
        placeholder="请输入名称查询"
        v-model="paperName"
        @keyup.enter.native="GetSchoolActivityList(1)"
      >
        <i slot="suffix" class="el-input__icon el-icon-search" @click="GetSchoolActivityList(1)"></i>
      </el-input>
    </div>
    <div class="yk-class-activity-add-btn-wrapper"
         @click="discuss()">
      <i class="wl-icon-tianjia1"></i>
      <span style="color:black;">新增讨论</span>
    </div>
    <!-- <div style="float: right;"
         class="yk-class-activity-add-btn-wrapper"
         @click="importDialogVisible=true">
      <i class="wl-icon-daoru1"></i>
      <span>学校资源库导入</span>
    </div> -->
    <div class="yt-interactions-line-division"></div>
    <div class="yk-interactions--inner table-light-style" v-show="totalCount>0">
      <el-table
        ref="multipleTable"
        :data="list"
        stripe
        tooltip-effect="dark"
        style="width: 100%"
        empty-text=" "
      >
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column prop="activityName" label="名称"></el-table-column>
        <el-table-column prop="CreateDisplayName" label="创建人" width="250"></el-table-column>
        <!-- <el-table-column prop="IsAuditing"
                         label="审核状态"
                         width="150">
        </el-table-column>-->
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <div class="yk-tem-button">
               <el-button size="mini"
                @click="editActivity(scope.row)"
                icon="el-icon-edit"
                type="primary"
                title="编辑"
               ></el-button>
              <!-- <el-button
                size="mini"
                @click="editActivity(scope.row)"
                icon="el-icon-view"
                type="primary"
                class="small-button"
              >查看</el-button> -->
              <el-button
                size="mini"
                @click="deleteActivity(scope.row.id)"
                icon="el-icon-delete"
                type="danger"
                title="删除"
              ></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="noDataShow" class="yk-nodata-source-content">
      <img src="~assets/images/the-last-new-nodata-imag.png" alt class="yk-prompt" />
      <div class="sp-noData">暂无内容，请新增讨论。</div>
    </div>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="onPageChangeHandler"
      :current-page="pageIndex"
      :page-sizes="[5 , 10, 15, 20]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
      v-show="totalCount>0"
    ></el-pagination>

    <!-- 弹窗（头脑风暴、讨论、投票） -->
    <el-dialog
      :before-close="handleClose"
      title="讨论"
      v-if="dialogFormVisibleBrainStormOrDiscuss"
      :visible.sync="dialogFormVisibleBrainStormOrDiscuss"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="82px">
        <el-form-item label="名称：">
          <el-input class="input-with-select" v-model="activityName"></el-input>
        </el-form-item>
        <el-form-item label="内容：">
          <el-input
            type="textarea"
            :rows="6"
            resize="none"
            class="input-with-select"
            v-model="activityContent"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片：">
          <oss-newthumbnail :url="urlAliyunOSS"
                            :files.sync="docJson"
                            format="image"
          v-bind:count="8"></oss-newthumbnail>
          <!-- <img :src="docJson" class="detail-img" alt style="height: 146px;width: 146px;" /> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="addoredit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { urlAliyunOSSThumb } from "api/v1";
import { importActivity } from 'api/v1.design.PrepareImport';
import {
  getSchoolActivityList,
  AddSchoolActivity,
  DeleteSchoolActivity,
  EditSchoolActivity
} from "api/v1.manager.schoolactivity";
import NewThumbnail from "components/AliyunOSS/NewThumbnail.vue";
export default {
  components: {
    "oss-newthumbnail": NewThumbnail,
  },
  props: {
    schoolCourseId: {
      type: String,
      default: ""
    },
    courseId: {
      type: String,
      default: ""
    },
    userType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      importDialogVisible:false,
      word: "",
      /** 分页 */
      totalCount: -1,
      pageSize: 10,
      pageIndex: 1,
      /** 查询条件 */
      paperType: "3",
      /** 返回列表 */
      list: [],
      /** */
      /* 颜色改变 */
      active: 1,
      menuShow: false,
      dialogFormVisibleBrainStormOrDiscuss: false,
      activityName: "",
      activityContent: "",
      ActivityRemake: "",
      activityType: 3,
        urlAliyunOSS: '/api/design/osssign/getsign',
      docJson: "",
      disabled: false,
      dataJson: [
        { name: "A", content: "" },
        { name: "B", content: "" },
        { name: "C", content: "" }
      ],
      activityId: "",
      activityRemake: "",
      paperName: "",
      loadingShow: false,
      noDataShow: false,
      ids: []
    };
  },
  created() {
    this.GetSchoolActivityList(1);
  },
  computed: {
    auth() {
      let auth = this.$store.state.auth;
      return { ...auth };
    }
  },
  methods: {
    ImportActivity() {
      importActivity(this.ids, this.courseId).then(rst => {
        if (rst.code>0) {
          this.GetSchoolActivityList(1);
          this.importDialogVisible = false;
          this.$message.success(rst.code);
        } else {
          this.$message.warning(rst.code);
        }
      });
    },
    /** 返回列表 */
    GetSchoolActivityList(page) {
      this.loadingShow = true;
      getSchoolActivityList(
        this.schoolCourseId,
        this.courseId,
        3,
        this.paperName,
        page,
        this.pageSize
      ).then(rst => {
        this.list = rst.list;
        this.loadingShow = false;
        if (this.list.length === 0) {
          this.noDataShow = true;
        } else {
          this.noDataShow = false;
        }
        this.totalCount = rst.pagination.totalCount;
        this.pageSize = rst.pagination.pageSize;
        this.pageIndex = rst.pagination.pageIndex;
      });
    },
    handleClose(done) {
      done();
      this.cancel();
    },
    // 新增弹框
    discuss() {
      this.activityType = 3;
      this.title = "讨论";
      this.activityName = this.getNowFormatDate() + "的讨论";
      this.dialogFormVisibleBrainStormOrDiscuss = true;
      this.disabled = false;
    },
    // 新增/编辑判断
    addoredit() {
      if (this.activityId === "") {
        this.disabled = true;
        this.AddFaceTeachActivity();
      } else {
        this.disabled = true;
        this.EditFaceTeachActivity();
      }
    },
    // 添加活动
    AddFaceTeachActivity() {
      var dataJson = JSON.stringify(this.dataJson);
      // var voteType = 0;
      if (this.activityContent === "") {
        this.activityContent = "暂无内容";
      }
      var imageurl = "";
      debugger;
      if (typeof this.docJson === "string") {
        imageurl = this.docJson;
      } else {
        this.docJson.forEach(function(url) {
          imageurl += url + ";";
        });
      }
      AddSchoolActivity(
        this.schoolCourseId,
        this.courseId,
        this.activityName,
        this.activityContent,
        this.voteType,
        dataJson,
        this.activityType,
        this.ActivityRemake,
        // this.docJson,
        imageurl,
        (this.questionType = 0),
        this.userType
      ).then(rst => {
        this.$message({
          type: "warning",
          message: rst.msg
        });
        if (rst.code > 0) {
          this.activityId = "";
          this.cancel();
          this.GetSchoolActivityList(1);
        }
        this.disabled = false;
      });
    },
    // 编辑活动
    EditFaceTeachActivity() {
      var dataJson = JSON.stringify(this.dataJson);
      // var voteType = 0;
      if (this.activityContent === "") {
        this.activityContent = "暂无内容";
      }
      var imageurl1 = "";
      if (typeof this.docJson === "string") {
        imageurl1 = this.docJson;
      } else {
        this.docJson.forEach(function(url) {
          imageurl1 += url + ";";
        });
      }
      EditSchoolActivity(
        this.activityId,
        this.activityName,
        this.activityContent,
        this.ActivityRemake,
        (this.questionType = 0),
        this.voteType,
        dataJson,
        // this.docJson
        imageurl1
      ).then(rst => {
        this.$message({
          type: "warning",
          message: rst.msg
        });
        if (rst.code > 0) {
          this.activityId = "";
          this.cancel();
          this.GetSchoolActivityList(this.pageIndex);
        }
        this.disabled = false;
      });
    },

    // 打开编辑活动弹窗
    editActivity(row) {
      this.disabled = false;
      this.activityId = row.id;
      this.activityType = 3;
      this.activityName = row.activityName;
      this.activityContent = row.activityContent;
      this.voteType = row.voteType;
      if (row.docJson.indexOf(";") > 0) {
        // this.docJson = row.docJson.split(";");
        var aa = row.docJson.split(";");
        aa.pop();
        this.docJson = aa;
      } else {
        this.docJson = row.docJson;
      }
      this.dataJson =
        row.dataJson === "" ? this.dataJson : eval("(" + row.dataJson + ")");
      this.activityRemake = row.activityRemake;
      if (
        this.activityType === 2 ||
        this.activityType === 3 ||
        this.activityType === 6 ||
        this.activityType === 9
      ) {
        this.dialogFormVisibleBrainStormOrDiscuss = true;
      }
    },
    onPageChangeHandler(page) {
      this.GetSchoolActivityList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetSchoolActivityList(1);
    },
    // 删除活动
    deleteActivity(id) {
      this.$confirm("此操作将删除当前活动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 删除班级
          DeleteSchoolActivity(id).then(rst => {
            this.$message.warning(rst.msg);
            this.GetSchoolActivityList(this.pageIndex);
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 获取当前时间方法
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        date.getHours() +
        seperator2 +
        date.getMinutes() +
        seperator2 +
        date.getSeconds();
      return currentdate;
    },
    // 取消弹窗方法
    cancel() {
      this.activityId = "";
      this.activityName = "";
      this.activityContent = "";
      (this.questionType = 1),
        (this.voteType = "正确错误"),
        (this.paperId = "");
      this.dataJson = [
        { name: "A", content: "" },
        { name: "B", content: "" },
        { name: "C", content: "" }
      ];
      this.dialogFormVisibleSign = false;
      this.dialogFormVisibleBrainStormOrDiscuss = false;
      this.dialogFormVisibleSignOrQuestion = false;
      this.dialogFormVisiblePaper = false;
      this.docJson = "";
    }
  }
};
</script>

<style lang="scss">
// .dark {
//   .yk-interactions__container__share {
//     .yk-btn-new-back-s {
//       position: fixed;
//       right: 30px;
//       top: 10px;
//       z-index: 2000;
//       padding: 2px 10px;
//       .wl-icon-fanhui2 {
//         font-size: 29px;
//       }
//     }
//     .yk-interactions--header {
//       padding: 15px;
//       .yk-sourse--nemu-btn-wrapper-pre-dis {
//         float: right;
//         margin-left: 10px;
//         width: 90px;
//         height: 32px;
//         background: rgba(63, 162, 255, 1);
//         border-radius: 3px;
//         line-height: 32px;
//         text-align: center;
//         color: #fff;
//       }
//     }
//     .el-pagination__total {
//       margin-right: 10px;
//       font-weight: 400;
//       //color: #fff;
//     }
//     .el-pagination__jump {
//       margin-left: 24px;
//       font-weight: 400;
//       //color: #fff;
//     }
//     .yk-class-activity-add-btn-wrapper {
//       padding: 10px;
//       margin-top: 20px;
//       text-align: center;
//       font-size: 17px;
//       /* color: #fff; */
//       border-radius: 10px;
//       border: 1px dashed black;
//       cursor: pointer;
//       .wl-icon-tianjia {
//         margin-right: 10px;
//         font-size: 25px;
//         border-radius: 50%;
//         color: black;
//         border: 1px solid black;
//         vertical-align: -2px;
//       }
//     }
//     .yk-interactions--header {
//       .el-input__inner {
//         height: 32px;
//         width: 160px;
//         background-color: #364256;
//         color: #fff;
//         border: none;
//         .el-icon-search {
//           font-size: 18px;
//           margin-top: -4px;
//           color: #409eff;
//         }
//       }
//       .el-input {
//         margin: 15px 20px -10px 0;
//       }
//       .interaction-tips {
//         float: left;
//         font-size: 18px;
//         color: #fff;
//         margin-top: 26px;
//       }
//     }
//     .detail-img {
//       height: 180px;
//       width: 200px;
//     }
//     .yk-tem-button {
//       .small-button {
//         padding: 7px 8px;
//       }
//     }
//   }
//   .is-line-left-solid {
//     border-left: 1px solid #596880;
//     padding: 0 20px 20px 20px;
//     .el-table {
//       background: unset;
//       border-radius: 10px;
//     }
//   }
//   .yt-interactions-line-division {
//     width: 98.5%;
//     height: 1px;
//     background: #596880;
//   }
//   .el-input__icon {
//     line-height: 32px;
//   }
//   .yk-interactions--inner{
//     .el-table__header-wrapper th {
//     background-color: #27313f;
//   }
//   .el-table thead {
//     color: #fff;
//   }
//   .el-table tr {
//     background-color: #3b4b65;
//     color: #fff;
//   }
//   .el-table--striped .el-table__body tr.el-table__row--striped td {
//     background: #333d51;
//   }
//   .el-table__row:hover {
//     background-color: #3b4b65 !important;
//   }
//   .el-table__body tr:hover > td {
//     background-color: #212e3e !important;
//   }
//   .el-table::before {
//     background-color: #364256;
//   }
//   .el-table__header-wrapper table thead th {
//   background-color: #3f5880;
// }
//   }
  

// }
  .yk-interactions__container__share {
    .yk-tem-button {
      .small-button {
        padding: 7px 8px;
      }
    }
    .yk-btn-new-back-s {
      position: fixed;
      right: 30px;
      top: 10px;
      z-index: 2000;
      padding: 2px 10px;
      .wl-icon-fanhui2 {
        font-size: 29px;
      }
    }
    .yk-interactions--header {
      padding: 15px;
      text-align: right;
      .yk-sourse--nemu-btn-wrapper-pre-dis {
        float: right;
        margin-left: 10px;
        width: 90px;
        height: 32px;
        background: rgba(63, 162, 255, 1);
        border-radius: 3px;
        line-height: 32px;
        text-align: center;
        color: #fff;
      }
      .el-input{
        width: 360px;
      }
    }
    .el-pagination__total {
      margin-right: 10px;
      font-weight: 400;
      //color: #fff;
    }
    .el-pagination__jump {
      margin-left: 24px;
      font-weight: 400;
      //color: #fff;
    }
    .yk-class-activity-add-btn-wrapper {
      float: left;
      width: 99%;
      padding: 10px;
      margin-top: 20px;
      text-align: center;
      font-size: 17px;
      /* color: #fff; */
      border-radius: 10px;
      color: black;
      border: 1px dashed black;
      cursor: pointer;
      .wl-icon-tianjia1 {
        margin-right: 10px;
        font-size: 25px;
        border-radius: 50%;
        color: black;
        border: 1px solid black;
        vertical-align: -2px;
      }
      .wl-icon-daoru1{
        margin-right: 10px;
        font-size: 25px;
        color: black;
        vertical-align: -2px;
      }
    }
    .yk-interactions--header {
      .el-input__inner {
        height: 32px;
        width: 160px;
        .el-icon-search {
          font-size: 18px;
          margin-top: -4px;
          color: #409eff;
        }
      }
      .el-input {
        margin: 15px 0px -10px 0;
      }
      .interaction-tips {
        float: left;
        font-size: 18px;
        color: #000;
        margin-top: 26px;
      }
    }
    .detail-img {
      height: 180px;
      width: 200px;
    }
  }
  .is-line-left-solid {
    border-left: 1px solid #e1e9f0;
    padding: 0 20px 20px 20px;
    .el-table {
      background: unset;
    }
  }
  .yt-interactions-line-division {
    width: 100%;
    height: 1px;
    background: #e1e9f0;
  }

</style>
